import AnimatedPercentage from './AnimatedPercentage';

export default AnimatedPercentage;
